/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { IPharmacyBill } from 'app/shared/model/pharmacy-bill.model';
import { AuditStatus } from 'app/shared/model/enumerations/audit-status.model';
import { AuditOutcome } from 'app/shared/model/enumerations/audit-outcome.model';

export interface IPharmacyAuditSummary {
  id?: string;
  startDate?: number | null;
  endDate?: number | null;
  discrepancyLoss?: number | null;
  discrepancyGain?: number | null;
  quantityLost?: number | null;
  quantityFound?: number | null;
  auditStatus?: keyof typeof AuditStatus | null;
  auditOutcome?: keyof typeof AuditOutcome | null;
  active?: boolean;
  microSec?: number;
  lastupdated?: number;
  timestampentry?: number;
  cursor?: number;
  newSync?: boolean | null;
  pharmacy?: IPharmacy;
  lossBill?: IPharmacyBill;
}

export const defaultValue: Readonly<IPharmacyAuditSummary> = {
  active: false,
  newSync: false,
};
